import type {
  CustomerBookingRequest,
  CustomerBookingResponse,
  ApiResponse,
} from "@/types/customer-booking";

const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_URL || "https://www.lilylanka.com";

export async function createCustomerBooking(
  payload: CustomerBookingRequest,
  token?: string,
): Promise<{
  success: boolean;
  data?: CustomerBookingResponse;
  error?: string;
}> {
  try {
    const headers: Record<string, string> = {
      accept: "text/plain",
      "Content-Type": "application/json",
    };

    // Add Keycloak authorization header if token is provided
    if (token) {
      headers.Authorization = `Bearer ${token}`;
      console.log("Keycloak Authorization header added");
    } else {
      console.warn("No token provided for booking request");
    }

    console.log(
      "Sending booking request to:",
      `${API_BASE_URL}/api/CustomerBookings`,
    );

    const response = await fetch(`${API_BASE_URL}/api/CustomerBookings`, {
      method: "POST",
      headers,
      body: JSON.stringify(payload),
    });

    console.log(
      "Booking response status:",
      response.status,
      response.statusText,
    );

    if (response.ok) {
      const apiResponse: ApiResponse<CustomerBookingResponse> =
        await response.json();
      // Extract the result from the API wrapper response
      if (apiResponse.result) {
        return { success: true, data: apiResponse.result };
      } else {
        return {
          success: false,
          error: apiResponse.message || "Booking failed",
        };
      }
    } else {
      const errorText = await response.text();
      console.error(
        `Booking failed with status ${response.status}:`,
        errorText,
      );

      // Provide helpful error message for 401
      if (response.status === 401) {
        return {
          success: false,
          error:
            "Unauthorized - Please ensure you are logged in with a valid Keycloak token",
        };
      }

      return { success: false, error: errorText || "Booking failed" };
    }
  } catch (error) {
    console.error("Booking error:", error);
    return { success: false, error: "Network error occurred" };
  }
}
